import React, {Fragment, useCallback, useState} from "react";
import ReactHookFormError from "./ReactHookFormError";
import ReactQuill from 'react-quill';
import {Controller} from "react-hook-form";
const FormItemRichText = ({ heading, name, formSectionName,  register, validate, control, formErrors }) =>
{
    const elementName = formSectionName === undefined ? name : formSectionName + '.' + name ;

    const toolbarOptions = [
    ];

    // We need to cache this function, otherwise the quill components will re-render empty
    // when a render occurs
    const handleTab = useCallback((range,context) => {
        return true ;
    }, []);

    const modules = {
        toolbar: toolbarOptions,
        keyboard: {
            bindings: {
                'tab': {
                    key: 9,
                    handler: handleTab
                }
            }
        }
    }

    return (
        <Fragment key={elementName}>
            { heading !== null && <label>{heading}</label> }
            <Controller
                control={control}
                name={elementName}
                defaultValue={[]}
                rules={{ required: false, validate: validate}}
                render={({ field: { onChange, value, name, ref },
                             fieldState: { invalid, isTouched, isDirty, error },
                             formState,
                         }) => <ReactQuill key={'q' + elementName} theme="snow"  modules={modules} value={value} onChange={onChange} height='200px' />}
            />
            <ReactHookFormError formErrors={formErrors} name={name}/>
        </Fragment>
    )
}

export default FormItemRichText;
